import React from 'react';
import { Navigate, Route, createRoutesFromElements } from 'react-router-dom';
import { useUser } from './shared/use-user';
import { pagePathnames, pageRoutes } from './pages/page-routes';
import { useRouting } from './shared/use-routing';
import { App } from './App';

function dummyLayout(props) {
    return props.children;
}

function ProtectedRoute({page: Page, layout, container, ...props}) {
    const {isLoading, userData} = useUser();

    if (isLoading) {
        return <div style={{height: '100vh'}}></div>;
    }

    if (!userData.isAuthenticated) {
        return <Navigate to={pagePathnames.start} replace />;
    }

    const Layout = layout ? layout : dummyLayout;
    
    return (
        <Layout>
            <Page {...props} />
        </Layout>
    );
};

function PublicRoute({page: Page, layout, ...props}) {
    const {isLoading, userData} = useUser();
    const {location} = useRouting();

    if (isLoading) {
        return <div style={{height: '100vh'}}></div>;
    }

    if (userData.isAuthenticated && location.pathname === pagePathnames.signIn) {
        return <Navigate to={pagePathnames.main} replace />;
    }

    const Layout = layout ? layout : dummyLayout;

    return (
        <Layout>
           <Page {...props} />
        </Layout>
    );
};

function getAppRoutes() {
    return createRoutesFromElements(
        <Route element={<App />}>
            {pageRoutes.map(({isProtected, page, layout, path}) => {
                const RouteElement = isProtected ? ProtectedRoute : PublicRoute;

                return (
                    <Route
                        path={path}
                        key={path}
                        element={<RouteElement page={page} layout={layout} />}
                    />
                );
            })}
        </Route>
    );
};

export {
    getAppRoutes
}
